export default __webpack_public_path__ + "static/media/api_code.21403708.svg";